<template>
    <span :class="config.class">
        <template v-if="config.component">
            <component :is="config.component" v-bind="config.componentConfig">
                {{ formattedValue }}
            </component>
        </template>
        <template v-else>
            {{ formattedValue }}
        </template>
    </span>
</template>

<script>
export default {
    name: 'SrTableColumn',
    props: {
        value: {
            type: [Array, Object, Number, String, Boolean, null, undefined, Symbol],
            required: false,
            default: '',
        },
        config: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        formattedValue() {
            if (this.config.formatter === undefined) {
                return this.value;
            }

            return this.config.formatter(this.value);
        },
    },
};
</script>
